
import ModalWindow from '@/ui-kit/components/modal/modal-window';
import ModalCommonProps from '@/ui-kit/components/modal/mixins/ModalCommonProps';
import { ModalSlotName } from '@/ui-kit/components/modal/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import Button from '@/ui-kit/components/button';
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import EmailInput from '@/components/inputs/email';

export default {
  name: 'ListingOwnerContactsRequestInfoModal',
  components: {
    ModalWindow,
    Typography,
    EmailInput,
    Button,
  },
  mixins: [ModalCommonProps],
  data() {
    return {
      ModalSlotName,
      TypographyType,
      StyleColorSchemeType,
      ButtonFillType,
      email: '',
      emailError: '',
    };
  },
  computed: {
    title() {
      return this.modalData.isUserAuthenticated
        ? 'Request Agent Information'
        : 'Request info';
    },
    description() {
      return this.modalData.isUserAuthenticated
        ? `The agent information could not be found. Please enter your email
           address if you would like Bōde support to contact you when this
           information is available.`
        : `Unfortunately we are missing some of the contact information for this agent.
           If you click on 'Send Request', the Bōde team will fix this issue and let you
           know when the listing has been updated.`;
    },
    hasValidEmail() {
      return this.modalData.email || (this.email && !this.emailError);
    },
  },
  methods: {
    handleEmailChange(value) {
      this.email = value;
    },
    handleEmailErrorChange({ errorMessage }) {
      this.emailError = errorMessage;
    },
    handleSendRequestClick() {
      this.closeHandler(this.modalData.email || this.email);
    },
  },
};
